<script>
    import { useNavigate, useLocation } from "svelte-navigator";
    import { isAuth } from "../services/auth.service";

    const navigate = useNavigate();
    const location = useLocation();

    $: if (!$isAuth) {
        navigate("/", {
            state: { from: $location.pathname },
            replace: true,
        });
    }
</script>

{#if $isAuth}
    <slot />
{/if}
